import { Component, OnInit, ElementRef, AfterViewInit, AfterViewChecked, forwardRef } from '@angular/core';

import { TextBoxViewModel } from '../../types/control.types';
import { AbstractValueControlBase } from '../../types/abstract-value-control-base';
import { ControlTypeName } from '../../types/control-type-name';
import { provideValueControlParent } from '../../utils/parent-finder';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'dy-text-box',
  templateUrl: './text-box.component.html',
  styleUrls: ['./text-box.component.css'],
  providers: [provideValueControlParent(TextBoxComponent)]
})
export class TextBoxComponent extends AbstractValueControlBase<TextBoxViewModel>
  implements OnInit, AfterViewChecked, AfterViewInit {
  type: string = ControlTypeName.textBox;
  isDesign: boolean = false;
  model: TextBoxViewModel;
  constructor(protected element: ElementRef) {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
    if (!this.model['placeholder']) {
      this.model['placeholder'] = '';
    }

    if (!this.model['id']) {
      this.model['id'] = '';
    }
  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();
  }

  ngAfterViewChecked(): void {
    this.handleValueChangeNotByAngularWay();
  }

  setModelValue(value: any) {
    // å¦ææ¯æ°ç»å¼ï¼é»è®¤è½¬æ¢ä¸ºå­ç¬¦ä¸²
    if (value instanceof Array) {
      value = value.join('-');
    }
    this.model.value = value;
  }

  valueChange(event: Event) {
    this.validate();
    super.valueChange(event);
  }
}
